<div class="kpi-card" [ngClass]="'kpi-card--' + (variant || 'default')">
    <span class="kpi-card__label">{{ label }}</span>
    <span class="kpi-card__value">{{ value }}</span>
    <span class="kpi-card__hint" *ngIf="hint">{{ hint }}</span>
</div>
